import _Vue from 'vue';
import router from 'vue-router';
interface IConfig {
  url: string;
}

export class RouterThen {
  resolve!: any;
  router!: router;
  constructor(router: any) {
    this.router = router;
  }
  request(config: IConfig) {
    return new Promise<Vue>((resolve, reject) => {
      // console.log('store resolve fn');
      this.resolve = resolve;
      this.router.push(config.url);
      // console.log('check router then resolve property: ', this.resolve);
    }).catch((err) => {
      throw new Error(err);
    });
  }
  push(config: IConfig) {
    return this.request(config);
  }
}

export default {
  install(Vue: typeof _Vue, options: any) {
    const myRouter = new RouterThen(options.router);
    Vue.prototype.$routerThen = myRouter;
    Vue.mixin({
      // beforeRouteUpdate(to, from, next) {
      //   console.log('route update', myRouter.resolve);
      //   next();
      // },
      beforeRouteEnter(to, from, next) {
        if (myRouter.resolve) {
          next((vm: _Vue) => {
            myRouter.resolve(vm);
            // myRouter.resolve = null;
          });
        } else {
          next();
        }
      },
    });
  },
};
